import React from 'react';
import { useSite } from '@edreamsodigeo/frontend-core';

import hotelsActiveSites from '../constants/hotelsActiveSites';
import hotelsActivePrimeSites from '~constants/hotelsActivePrimeSites';

interface WithHotelsEnabledArgs<Props> {
  Component: React.FC<Props>;
  FallbackComponent: React.FC<Props>;
  options?: {
    onlyPrimeSites?: boolean;
  };
}

type WithHotelsEnabled = <Props>(
  args: WithHotelsEnabledArgs<Props>
) => React.FC<Props>;

export const withHotelsEnabled: WithHotelsEnabled = <Props,>({
  Component,
  FallbackComponent,
  options = {},
}: WithHotelsEnabledArgs<Props>) => {
  return (props: React.PropsWithChildren<Props>) => {
    const site = useSite();
    const listOfActiveSites = options.onlyPrimeSites
      ? hotelsActivePrimeSites
      : hotelsActiveSites;
    const isEnabled = listOfActiveSites.includes(site);

    return isEnabled ? (
      <Component {...props} />
    ) : (
      <FallbackComponent {...props} />
    );
  };
};
